import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import { BrowserRouter } from "react-router-dom";

const root = ReactDOM.createRoot(document.getElementById("root"));

const AppTree = (
  <BrowserRouter>
    <App />
  </BrowserRouter>
);

if (process.env.NODE_ENV === 'production') {
  root.render(
    <React.StrictMode>
      {AppTree}
    </React.StrictMode>
  );
} else {
  root.render(AppTree);
}
